import AccessLevels from './AccessLevels';

/**
 * Default authenticated landing path for the admin app (login, invite accept, etc.).
 * Server users stay on redeem coupons; Admin and SuperAdmin go to the dashboard.
 */
export function getPostLoginPath(accessLevel) {
  if (
    accessLevel === AccessLevels.Admin
    || accessLevel === AccessLevels.SuperAdmin
  ) {
    return '/dashboard';
  }
  return '/redeemCoupon';
}
